import { Tooltip, TooltipProps } from '@mui/material';

type WithOptionalTooltipProps = {
  show: boolean;
} & TooltipProps;

export const WithOptionalTooltip: React.FC<WithOptionalTooltipProps> = ({
  show,
  children,
  ...props
}) => {
  if (!show) return children;

  return (
    <Tooltip {...props}>
      <span>{children}</span>
    </Tooltip>
  );
};
